import { useLocationsPassengerAddressesDestroyMutation } from '@bambi/api-client/bambi';
import type { PassengerAddress } from '@bambi/api-client/schemas';
import { useCallback } from 'react';

import { PassengerAddressFormModal } from './PassengerAddressFormModal';
import { useAppDispatch } from 'src/app/store/hooks';
import { ManageCell as BaseManageCell } from 'src/common/DataGrid/ManageCell';
import { useModal } from 'src/common/modals/useModal';
import { show } from 'src/common/primitives/Toast/toast.slice';
import formatServerError from 'src/common/util/serverErrorFormatter';

interface ManageCellProps {
  address: PassengerAddress;
}
export function ManageCell({ address }: ManageCellProps) {
  const { open, setOpen, closeModal } = useModal();
  const [deleteAddress] = useLocationsPassengerAddressesDestroyMutation();
  const dispatch = useAppDispatch();

  const handleEdit = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleDelete = useCallback(async () => {
    try {
      await deleteAddress({ id: address.id }).unwrap();
      dispatch(
        show({
          title: 'Address deleted successfully',
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(
        show({
          title: 'Failed to delete address',
          description: formatServerError(error),
          type: 'error',
        })
      );
    }
  }, [address, deleteAddress, dispatch]);

  return (
    <>
      <BaseManageCell
        items={[
          {
            label: 'Edit',
            icon: 'pencil',
            onClick: handleEdit,
          },
          {
            label: 'Delete',
            icon: 'trash',
            onClick: handleDelete,
          },
        ]}
      />
      <PassengerAddressFormModal
        open={open}
        setOpen={setOpen}
        onClose={closeModal}
        passengerAddress={address}
      />
    </>
  );
}
